/**
 * AccessDenied - landing for users without RiskManager or SuperAdmin roles.
 * Shown by RoleGate. Includes the resolved UPN so the user can verify they
 * are signed in with the expected account before requesting role assignment.
 */

import { useAuth } from '@/contexts/AuthContext';
import type { AuthUser } from '@/contexts/AuthContext';

export function AccessDenied({ user }: { user: AuthUser }): JSX.Element {
  const { logout } = useAuth();
  return (
    <div className="auth-gate">
      <div className="auth-gate__card">
        <h1 className="auth-gate__title">You don&rsquo;t have access</h1>
        <p className="auth-gate__body">
          The PCB Risk Mgmt Panel requires the <strong>RiskManager</strong> or{' '}
          <strong>SuperAdmin</strong> role.
          <br />
          <br />
          Signed in as <code>{user.upn}</code>
          <br />
          Roles: <code>{user.roles.join(', ') || '(none)'}</code>
          <br />
          <br />
          Contact a SuperAdmin to assign the RiskManager role via the ROP
          Admin panel (Users &amp; Roles).
        </p>
        <button className="btn btn--ghost" onClick={() => void logout()}>
          Sign out
        </button>
      </div>
    </div>
  );
}
